import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {};

function fgwLocations() {
    return (
        <React.Fragment>
            <p>
                <strong>Linux</strong>: <code className="language-text">/usr/local/bin/</code>
                <br />
                <strong>Windows</strong>:{' '}
                <code className="language-text">C:\Program Files\Signiant\Flight Gateway\</code>
            </p>
        </React.Fragment>
    );
}

fgwLocations.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(fgwLocations);
